import React, { useState } from "react";
import "./Contact.scss";
import { ReactSVG } from "react-svg";
import SpecialButton from "../UI/SpecialButton";
import Swal from "sweetalert2";
import { useMutation } from "react-query";
import { postContactUs } from "../../api/index";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Contact = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      // Form is valid, perform submission logic here
      try {
        mutate({ ...formData });
      } catch (e) {
        console.log(e);
      }

      console.log("Form submitted:", formData);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) {
      errors.name = "Please enter your name";
    }
    if (!formData.email) {
      errors.email = "Please enter your email";
    } else if (!isValidEmail(formData.email)) {
      errors.email = "Please enter a valid email";
    }
    if (!formData.phoneNumber) {
      errors.phoneNumber = "Please enter your contact number";
    }
    if (!formData.message) {
      errors.message = "Please enter your message";
    }
    return errors;
  };

  const isValidEmail = (email) => {
    // Simple email validation logic
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const { mutate } = useMutation(postContactUs, {
    onSuccess: (data) => {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Query submitted successfully!",
        text: "We'll get back to you soon!",
        showConfirmButton: true,
        timer: 2000,
      });
      window.location.reload();
    },
    onError: (error) => {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Contact Us Form Failed!!!",
        text: error?.response?.data?.message,
        showConfirmButton: true,
        timer: 2000,
      });
    },
  });

  return (
    <div className="contact-us-section" id="contact-us">
      <h2 className="heading-services">Ask us a Question</h2>
      <div className="about_line"></div>
      <p>
        Just send us your questions & concerns. We'll give you the help you
        need.
      </p>

      <div className="form-main-container">
        <ReactSVG className="ortho-icon" src="/icons/menu/orthoicon.svg" />
        <div className="form-container">
          <form className="form" onSubmit={handleSubmit}>
            <div className="form-left">
              <div className="form-item">
                <input
                  type="text"
                  maxLength={255}
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
                {errors.name && <div className="error">{errors.name}</div>}
              </div>
              <div className="form-item">
                <input
                  type="email"
                  maxLength={255}
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                {errors.email && <div className="error">{errors.email}</div>}
              </div>
              <div className="form-item">
                <input
                  type="number"
                  maxLength={255}
                  name="phoneNumber"
                  placeholder="Contact Number"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
                {errors.phoneNumber && (
                  <div className="error">{errors.phoneNumber}</div>
                )}
              </div>
            </div>
            <div className="form-right">
              <div className="form-item">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleInputChange}
                />
                {errors.message && (
                  <div className="error">{errors.message}</div>
                )}
              </div>
            </div>
          </form>{" "}
          <SpecialButton
            onClick={handleSubmit}
            className="form-button"
            type="submit"
          >
            Submit
          </SpecialButton>
        </div>
      </div>
    </div>
  );
};

export default Contact;
